<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex
      v-for = "(value, report) in reports"
      v-if = "!report.startsWith('.')"
      :key = 'report.key'
      >
      <v-card>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex xs5>
              <div class='title' v-text='value.name'>
              </div>
          </v-flex>
          <v-flex>
            <v-card-media
            height = '100px'
            contain
            >
          </v-card-media>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
    <v-container fluid>
    <v-layout row wrap>
      <v-flex xs5>
      <v-btn flat @click.native.stop='openReport(report)'> Open report </v-btn>
    </v-flex>
<!--     <v-flex xs1 offset-xs6>
      <v-btn flat icon small round @click.native.stop='changeImage(project)'>
        <v-icon>photo</v-icon>
      </v-btn>
            <input type='file' id='pictureInput' style="display:none" @change='handleFiles(this.files)'/>
    </v-flex> -->
    </v-layout>
    <v-dialog
    fullscreen
  v-model='dialog'
  transition='dialog-bottom-transition'
  v-bind:hide-overlay='true'
>
  <v-card>
    <v-toolbar class="theme--dark primary">
      <v-btn icon @click.native='closeReport' dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{$route.params.id}}</v-toolbar-title>
    </v-toolbar>
    <router-view> </router-view>
  </v-card>
</v-dialog>
    </v-container>
    </v-card-actions>
  </v-card>
  </v-flex>
  </v-layout>
  </v-container>
</template>
<script>
  import {db} from '../../firebase/firebase'
  export default {
    name: 'report-selector',
    data () {
      return {
        dialog: false,
        reportHtml: ''
      }
    },
    created: function () {
      // let ref = firestore.ref().child('Valenica/Reports/LandUse/html/LandUsePlanasofApril2018.html')
      // ref.getDownloadURL().then(function (url) {
      //   let xhr = new XMLHttpRequest()
      //   xhr.responseType = 'blob'
      //   xhr.onload = function (event) {
      //     this.reportHtml = xhr.response
      //   }
      //   xhr.open('GET', url)
      //   xhr.send()
      // })
    },
    firebase: function () {
      return {
        reports: {
          source: db.ref('projects/' + this.$route.params.projectid + '/data/reports'),
          asObject: true
        }
      }
    },
    methods: {
      openReport (reportselectid) {
        this.$router.push({name: 'BasicReport', params: {reportid: reportselectid}})
        this.dialog = true
      },
      closeReport () {
        this.dialog = false
        this.$router.replace({name: 'ReportSelector'})
      },
      handleFiles (files) {
        console.log(files)
      },
      changeImage (projectName) {
        var fileElem = document.getElementById('pictureInput')
        fileElem.click()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/ReportSelector.vue